import React from 'react';
import StoreManageSections from './StoreManageSections';
import StoreManageModals from './StoreManageModals';
import Skeleton from '../../../shared/components/ui/Skeleton';

const StoreManageLoadingSkeleton = () => (
  <section className="appointments-v2-section" aria-label="Loading manage data">
    <div className="appointments-v2-kpi-grid">
      {Array.from({ length: 4 }).map((_, index) => (
        <article key={`manage-kpi-skeleton-${index}`} className="appointments-v2-kpi-card">
          <Skeleton height={12} width="55%" />
          <Skeleton height={30} width="45%" />
          <Skeleton height={12} width="70%" />
        </article>
      ))}
    </div>
  </section>
);

const StoreManageView = ({ controller, storeName, storeUuid }) => {
  const showInitialSkeleton = controller.isGlobalRequestLoading
    && controller.parentSections.length === 0
    && !controller.isModalOpen
    && !controller.isCounterModalOpen
    && !controller.isEditModalOpen;

  if (showInitialSkeleton) {
    return (
      <div className="store-manage-container">
        <StoreManageLoadingSkeleton />
      </div>
    );
  }

  return (
    <div className="store-manage-container">
    <StoreManageSections
      showSections={true}
      parentSections={controller.parentSections}
      sectionStats={controller.sectionStats}
      handleEditSection={controller.handleEditSection}
      handleToggleSectionStatus={controller.handleToggleSectionStatus}
      handleDownloadQR={controller.handleDownloadQR}
      setDeleteSectionTarget={controller.setDeleteSectionTarget}
      openCounterModal={controller.openCounterModal}
      openModal={controller.openModal}
      openZoneModal={controller.openZoneModal}
      storeName={storeName}
      storeUuid={storeUuid}
    />

    <StoreManageModals
      showSections={true}
      isModalOpen={controller.isModalOpen}
      closeModal={controller.closeModal}
      formValues={controller.formValues}
      handleFieldChange={controller.handleFieldChange}
      floorZones={controller.floorZones}
      isZoneLoading={controller.isZoneLoading}
      isZoneModalOpen={controller.isZoneModalOpen}
      zoneFormValues={controller.zoneFormValues}
      zoneModalFloorZones={controller.zoneModalFloorZones}
      sectionFormError={controller.sectionFormError}
      zoneFormError={controller.zoneFormError}
      counterFormError={controller.counterFormError}
      editFormError={controller.editFormError}
      closeZoneModal={controller.closeZoneModal}
      handleZoneFormChange={controller.handleZoneFormChange}
      handleCreateZone={controller.handleCreateZone}
      isZoneSaving={controller.isZoneSaving}
      isSaving={controller.isSaving}
      handleSave={controller.handleSave}
      isCounterModalOpen={controller.isCounterModalOpen}
      activeCounterMeta={controller.activeCounterMeta}
      counterSection={controller.counterSection}
      closeCounterModal={controller.closeCounterModal}
      filterStatus={controller.filterStatus}
      setFilterStatus={controller.setFilterStatus}
      sortKey={controller.sortKey}
      setSortKey={controller.setSortKey}
      isCounterLoading={controller.isCounterLoading}
      counterList={controller.counterList}
      displayCounters={controller.displayCounters}
      handleToggleCounter={controller.handleToggleCounter}
      setDeleteTarget={controller.setDeleteTarget}
      deleteTarget={controller.deleteTarget}
      handleDeleteCounter={controller.handleDeleteCounter}
      counterForm={controller.counterForm}
      handleCounterFormChange={controller.handleCounterFormChange}
      counterBaseName={controller.counterBaseName}
      nextCounterNumber={controller.nextCounterNumber}
      handleAddCounters={controller.handleAddCounters}
      isCounterSaving={controller.isCounterSaving}
      isEditModalOpen={controller.isEditModalOpen}
      editSection={controller.editSection}
      setIsEditModalOpen={controller.setIsEditModalOpen}
      setEditSection={controller.setEditSection}
      isEditSaving={controller.isEditSaving}
      editFormValues={controller.editFormValues}
      editFloorZones={controller.editFloorZones}
      handleEditFormChange={controller.handleEditFormChange}
      handleUpdateSection={controller.handleUpdateSection}
      setDeleteSectionTarget={controller.setDeleteSectionTarget}
      deleteSectionTarget={controller.deleteSectionTarget}
      isDeletingSection={controller.isDeletingSection}
      handleDeleteSection={controller.handleDeleteSection}
      sectionCreateConflict={controller.sectionCreateConflict}
      isSectionCreateConflictSaving={controller.isSectionCreateConflictSaving}
      closeSectionCreateConflict={controller.closeSectionCreateConflict}
      handleConfirmSectionCreateConflict={controller.handleConfirmSectionCreateConflict}
      isGlobalRequestLoading={controller.isGlobalRequestLoading}
    />
  </div>
  );
};

export default StoreManageView;
